import {ChangeDetectionStrategy, Component} from '@angular/core';
import {OffsetModifier} from '@popperjs/core/lib/modifiers/offset';
import {createPopperDropdownOffsetModifier} from '../../../../components/popper-utils/modifiers/popper-dropdown-offset';
import {createPopperReferenceWideModifier} from '../../../../components/popper-utils/modifiers/popper-reference-wide';
import {PopperOptions} from '../../../../components/popper-utils/popper-options';
import {SecurityAutocompleteListComponent} from '../../../../components/security-autocomplete';
import {ChartSecurityInputComponent} from '../chart-security-input.component';

@Component({
    selector: 'ul[securityAutocompleteList]',
    templateUrl: '../../../../components/security-autocomplete/security-autocomplete-list.component.html',
    styleUrls: ['../../../../components/security-autocomplete/security-autocomplete-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SecurityAutocompleteListModComponent extends SecurityAutocompleteListComponent {

    public readonly chartSecurityInputComponent = this.injector.get(ChartSecurityInputComponent);

    protected override initPopper(popperOptions: PopperOptions = {}): void {
        const offsetModifier: OffsetModifier = {
            ...createPopperDropdownOffsetModifier(),
            options: {
                offset: () => this.getOffsetValueForPopper()
            }
        };

        popperOptions = {
            modifiers: [
                offsetModifier,
                createPopperReferenceWideModifier()
            ],
            ...popperOptions
        };

        super.initPopper(popperOptions);
    }

    private getOffsetValueForPopper(): [number, number] {
        const rect = this.chartSecurityInputComponent.chartIFrame.getBoundingClientRect();

        return [rect.left, rect.top];
    }

}
